import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-summary-list-col",
    templateUrl: "./sps-summary-list-col.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsSummaryListColComponent {
    static readonly displayName = "sps-summary-list-col";
    static readonly props = {
        width: "string",
        borderless: "boolean",
        lean: "boolean",
        leaner: "boolean",
    };

    @Input()
    @HostBinding("style.width")
    width: string;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--borderless")
    borderless: boolean;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--lean")
    lean: boolean;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--leaner")
    leaner: boolean;

    @HostBinding("class.sps-content-row__col") readonly baseClass = true;
}
